import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { PaymentService } from "../../services";
import { asQuery } from "../../services/common";
import { DASH_STALE } from "./shared";

// Paginated buyer payments dashboard table ({ list, count }).
export function useBuyerPayments(token: string | undefined, params: any) {
  return useQuery({
    queryKey: ["payments", "buyer", token, params],
    queryFn: () =>
      asQuery<any>(PaymentService.getBuyerPayments(token as string, params)),
    enabled: !!token,
    staleTime: DASH_STALE,
    placeholderData: keepPreviousData,
  });
}

// Paginated seller payments dashboard table ({ list, count }).
export function useSellerPayments(token: string | undefined, params: any) {
  return useQuery({
    queryKey: ["payments", "seller", token, params],
    queryFn: () =>
      asQuery<any>(PaymentService.getSellerPayments(token as string, params)),
    enabled: !!token,
    staleTime: DASH_STALE,
    placeholderData: keepPreviousData,
  });
}
